// The relay carries connection state and actor identifiers only.
export function requestOutlookConnectionStatus(channel, actorType, actorId) {
  channel.postMessage({ __echo_relay_type: "outlook-mail-connection-request", actor_type: actorType, actor_id: actorId });
}
export function respondToOutlookConnectionRequests(channel, actorType, actorId, getConnectionState) {
  const handler = (event) => {
    const request = event.data;
    if (request?.__echo_relay_type !== "outlook-mail-connection-request" || request.actor_type !== actorType || String(request.actor_id) !== String(actorId)) return;
    channel.postMessage({ __echo_relay_type: "outlook-mail-connection", actor_type: actorType, actor_id: actorId, payload: { connected: getConnectionState() === "connected" } });
  };
  channel.addEventListener("message", handler);
  return () => channel.removeEventListener("message", handler);
}
